// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_r9";
export var checkboxInputColumn = "v_sb";
export var inputOptionRow = "v_qq";
export var inputOptionColumn = "v_qr";